export const disableF5 = (e: KeyboardEvent) => {
  const f5Key = 'F5';
  const f5keyCode = 116;
  if (e.key === f5Key || e.keyCode === f5keyCode) {
    e.preventDefault();
  }
};
